<template>
  <el-drawer
    title="服务产品详情"
    append-to-body
    :close-on-press-escape="false"
    :visible.sync="show"
    size="45%"
    direction="rtl">
    <div
      v-loading="loading"
      class="detail-drawer-wrap">
      <el-form label-width="85px">
        <el-form-item label="服务名称：">{{ ruleForm.servName }}</el-form-item>
        <el-form-item label="服务分类：">{{ ruleForm.className }}</el-form-item>
        <el-form-item label="服务首图：">
          <image-list
            :list="ruleForm.image"
            :listType="3" />
        </el-form-item>
        <el-form-item label="所属机构：">{{ ruleForm.servOrgName }}</el-form-item>
        <el-form-item label="上架状态：">{{ ruleForm.status === 1 ? '已上架' : '未上架' }}</el-form-item>
        <el-form-item label="排序值：">{{ ruleForm.sort }}</el-form-item>
        <el-form-item label="咨询次数：">{{ ruleForm.consultCount }}</el-form-item>
        <el-form-item label="服务简介：">
          <div style="line-height: 1.8;">{{ ruleForm.introduction }}</div>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.servAttrs && ruleForm.servAttrs.length > 0"
          label="扩展属性：">
          <el-table
            style="magin: 8px 0"
            border=""
            :data="ruleForm.servAttrs">
            <el-table-column
              prop="key"
              label="标题"
              width="180">
            </el-table-column>
            <el-table-column
              prop="value"
              label="内容">
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="服务详情：">
          <desc-images v-model="ruleForm.contentImages"></desc-images>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>
<script>
import OrgService from '@/service/org-service'
import ImageList from '@/components/image-list.vue'
import DescImages from '@/components/public/desc-images.vue'
export default {
  name: 'DetailDrawer',
  components: { ImageList, DescImages },
  data() {
    return { show: false, loading: false, config: { id: null }, ruleForm: { image: '', contentImages: [] }}
  },
  methods: {
    fetchInfo() {
      this.loading = true
      OrgService.getserv({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, contentImages, servAttrs } = res.data
          if (result === 0) {
            this.$set(this, 'ruleForm', {
              ...res.data,
              contentImages: this.$splitImage(contentImages),
              servAttrs: JSON.parse(servAttrs)
            })
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    fetch(options) {
      this.config = { ...this.config, ...options }
      this.show = true
      this.fetchInfo()
    }
  }
}
</script>
<style lang="stylus" scoped>
  .images-wrap {
    width 256px
    height 400px
    overflow-y auto
  }
</style>
